import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { useQuery } from '@sequencehq/api'

export const useFetchCustomerQuery = (customerId?: string) => {
  const query = useQuery(
    dashboardv99990101Client.getCustomer,
    {
      id: customerId ?? ''
    },
    { enabled: !!customerId }
  )

  return {
    customerDetails: query.data,
    loading: query.isLoading,
    error: query.isError,
    refetch: query.refetch
  }
}
